// Fotos subidas (/api/files/public/): 2 reintentos con espera; si siguen fallando, placeholder claro.
export const PLACEHOLDER = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 420"><rect width="300" height="420" rx="18" fill="#141414"/>' +
  '<rect x="1" y="1" width="298" height="418" rx="18" fill="none" stroke="#2a2a2a" stroke-width="2"/>' +
  '<text x="150" y="205" fill="#777" font-family="sans-serif" font-size="18" text-anchor="middle">Imagen no</text>' +
  '<text x="150" y="232" fill="#777" font-family="sans-serif" font-size="18" text-anchor="middle">disponible</text></svg>'
);

export const uniqueMatches = (list, game) => {
  const seen = new Set();
  return (list || []).filter((m) => {
    const k = [m.game_slug || game, m.set_name, m.number, m.language].map((v) => String(v || "").trim().toLowerCase()).join("|");
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
};

export function installImageFallback() {
  window.addEventListener("error", (e) => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement)) return;
    const src = img.currentSrc || img.src || "";
    if (!src.includes("/api/files/public/") || img.dataset.hitFailed) return;
    const n = Number(img.dataset.hitRetry || 0);
    if (n < 2) {
      img.dataset.hitRetry = String(n + 1);
      setTimeout(() => {
        const u = new URL(src);
        u.searchParams.set("r", String(n + 1));
        img.removeAttribute("srcset");
        img.src = u.toString();
      }, 1500 * (n + 1));
      return;
    }
    img.dataset.hitFailed = "1";
    img.removeAttribute("srcset");
    img.src = PLACEHOLDER;
  }, true);
}
